import type { AlertProps, SnackbarProps } from '@mui/material'
import { create } from 'zustand'

export interface ToastOptions {
  key?: string
  message?: SnackbarProps['message']
  title?: SnackbarProps['message']
  type?: AlertProps['color']
  closeButton?: boolean
  action?:
  | SnackbarProps['action']
  | ((hide: () => void) => SnackbarProps['action'])
  autoHideDuration?: SnackbarProps['autoHideDuration']
  showSnackBarUnderTopBar?: boolean
  disableCloseOnClickAway?: boolean
}
type UseToastType = {
  open: boolean
  options: ToastOptions | null
}

export const useToast = create<UseToastType>(() => ({
  open: false,
  options: null,
}))

export const showToast = (options: ToastOptions) =>
  useToast.setState(() => ({ open: true, options }))

export const hideToast = () => useToast.setState(() => ({ open: false }))
